module.exports = __webpack_public_path__ + "files/cfdade8c8fdecc29d4c84f7313cfe6e6.png";